import { type SingleLineGroupItem, type SingleLineItem } from "../types";

export function isGroupNavItem(
  item: SingleLineItem | SingleLineGroupItem,
): item is SingleLineGroupItem {
  return "subMenuItems" in item;
}

export function isPageNavItem(
  item: SingleLineItem | SingleLineGroupItem,
): item is SingleLineItem {
  return "url" in item;
}
